import { createSlice } from '@reduxjs/toolkit'
import {LOCALES} from "../i18n";

const initialState = {
    lang: LOCALES.RUSSIAN,
}

export const counterSlice = createSlice({
    name: 'lang',
    initialState,
    reducers: {
        changeLang: (state,{payload}) => {

            state.lang = payload
        },

    },
})

// Action creators are generated for each case reducer function
export const {changeLang} = counterSlice.actions

export default counterSlice.reducer